export default function (props: {value?:string | number, unit?: string, default2?: string | number}) {
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  return <div className="showTextvalue">{(props.value || props.default2)?<span>{props.value || props.default2}&nbsp;&nbsp;&nbsp;{props.unit}</span>: ''}</div>
}